import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from './../../config/axiosConfig';

export const fetchTaxes = createAsyncThunk('taxes/fetchTaxes', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get('/taxes');
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to fetch taxes');
  }
});

export const createTax = createAsyncThunk('taxes/createTax', async (taxData, thunkAPI) => {
  try {
    const response = await axiosInstance.post('/taxes', taxData);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to create tax');
  }
});

export const updateTax = createAsyncThunk('taxes/updateTax', async ({ id, updatedData }, thunkAPI) => {
  try {
    const response = await axiosInstance.put(`/taxes/update/${id}`, updatedData);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to update tax');
  }
});

export const deleteTax = createAsyncThunk('taxes/deleteTax', async (id, thunkAPI) => {
  try {
    await axiosInstance.delete(`/taxes/delete/${id}`);
    return id; // Return ID to remove from local state
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to delete tax');
  }
});

const taxesSlice = createSlice({
  name: 'taxes',
  initialState: {
    taxes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchTaxes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTaxes.fulfilled, (state, action) => {
        state.loading = false;
        state.taxes = action.payload;
      })
      .addCase(fetchTaxes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createTax.fulfilled, (state, action) => {
        state.taxes.push(action.payload.data);
      })
      .addCase(createTax.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateTax.fulfilled, (state, action) => {
        const index = state.taxes.findIndex(tax => tax.id === action.payload.id);
        if (index !== -1) {
          state.taxes[index] = action.payload.data;
        }
      })
      .addCase(updateTax.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(deleteTax.fulfilled, (state, action) => {
        state.taxes = state.taxes.filter(tax => tax.id !== action.payload.id);
      })
      .addCase(deleteTax.rejected, (state, action) => {
        state.error = action.payload;
      });
  }
});

export default taxesSlice.reducer;
